var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('google-maps-loader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":_vm.MAP_KEY},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('google-maps-marker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map},on:{"click":function($event){return _vm.infoWindow(marker.infoWindow)}}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }